<div class="drawer-content notifications-panel">
  <header class="title-area">
    <app-titulo titulo="Notificaciones"></app-titulo>
    <mat-icon
      class="close-icon"
      aria-hidden="false"
      aria-label="Cerrar panel de notificaciones"
      fontIcon="close"
      (click)="closePanel()"></mat-icon>
  </header>

  <div class="notifications-area">
    @if (isInitialLoading()) {
      <div class="loading-notifications">
        <app-load-spinner></app-load-spinner>
      </div>
    } @else if (error()) {
      <app-data-error
        [titulo]="error()"
        subtitulo=""
        (reintentar)="notificationRefresh()"></app-data-error>
    } @else if (hasNoNotifications()) {
      <app-no-data
        titulo="No hay notificaciones"
        icono="notifications"
        subtitulo="Aquí aparecerán las notificaciones relacionadas con tu cuenta."></app-no-data>
    } @else {
      <div class="notification-header">
        <span class="notifications-header-text textos-title-medium"
          >Nuevas
          <div class="news-circle"></div
        ></span>
        <a
          [class.disabled]="isDisableMarkAsRead()"
          class="mark-all-read-button textos-body-medium"
          (click)="markSelectedAsRead()">
          Marcar como leídas
        </a>
      </div>
      <div class="notifications-list">
        @for (item of unreadNotifications(); track item.id; let last = $last) {
          <div class="notifications-item-wrapper" [class.bottom-line]="!last">
            <app-notification
              [notification]="item"
              [isSelected]="isSelected(item.id)"
              [showCheckbox]="true"
              (selectionChange)="toggleSelection(item.notification_id)" />
          </div>
        }
      </div>
      <span class="readed-header textos-title-medium">Leídas</span>
      <div class="notifications-list">
        @for (item of readNotifications(); track item.id; let last = $last) {
          <div class="notifications-item-wrapper" [class.bottom-line]="!last">
            <app-notification [notification]="item" [showCheckbox]="false" />
          </div>
        }
        @if (readNotifications().length === 0) {
          <div class="no-read-notifications textos-body-medium">
            No hay notificaciones leídas.
          </div>
        }
      </div>
    }
  </div>
</div>
